import React, { useState } from 'react';
import { API_BASE_URL } from '../services/api';

const Register = ({ onRegister, onSwitchToLogin }) => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [invitationCode, setInvitationCode] = useState(''); // 添加邀请码状态
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // 基本验证
    if (password !== confirmPassword) {
      setError('密码不匹配');
      return;
    }
    
    if (password.length < 6) {
      setError('密码长度至少6位');
      return;
    }
    
    // 检查邀请码
    if (!invitationCode.trim()) {
      setError('邀请码是必需的');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_BASE_URL}/auth/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          email,
          password,
          invitation_code: invitationCode, // 添加邀请码到请求中
        }),
      });

      const data = await response.json();

      if (response.ok) {
        // 注册成功，切换到登录页面
        onRegister(data.message);
      } else {
        setError(data.detail || '注册失败');
      }
    } catch (err) {
      setError('网络错误: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="register-form">
        <h2>创建账户</h2>
        <p>请填写以下信息</p>
        {error && <div className="error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">用户名:</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              placeholder="选择一个用户名"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="email">邮箱:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="输入您的邮箱地址"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="invitationCode">邀请码:</label>
            <input
              type="text"
              id="invitationCode"
              value={invitationCode}
              onChange={(e) => setInvitationCode(e.target.value)}
              required
              placeholder="输入邀请码"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">密码:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="创建密码 (最少6位)"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="confirmPassword">确认密码:</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              placeholder="确认您的密码"
            />
          </div>
          
          <button type="submit" className="primary-button" disabled={loading}>
            {loading ? '创建账户中...' : '创建账户'}
          </button>
        </form>
        
        <div className="auth-switch">
          <p>
            已有账户?{' '}
            <button onClick={onSwitchToLogin} className="link-button">
              点此登录
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;